import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_7: FaireProductEntity = {
  token: "legacy_prod_roen-7",
  type: "product",
  name: "Villa Capri",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/14df7e9510a1f019339ecc468d7eec982f18096d6c44245bf409b760fdcd9456.webp",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
